import { Flex as ChakraFlex, FlexProps as ChakraFlexProps } from '@chakra-ui/react';
import React from 'react';

export function Flex(props: ChakraFlexProps) {
  return <ChakraFlex {...props} />;
}
